import { Pipe, PipeTransform } from '@angular/core';
import { LookupService } from '@core/service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'diagnosisDescriptionByCode',
    standalone: false
})
export class DiagnosisDescriptionByCodePipe implements PipeTransform {

  constructor(private lookupService: LookupService) { }

  transform(icdCodeName: string, tenantId: string): Observable<string> {
    return (icdCodeName && tenantId)
      ? this.lookupService.getIcdCodeByName(tenantId, icdCodeName).pipe(map(el => el ? el.description : icdCodeName))
      : of(icdCodeName);
  }

}
